
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.795 51.905H64.4v-.7a7.237 7.237 0 00-7.245-7.245H36.47v-5.67c8.12-.735 14.455-7.56 14.455-15.855C50.925 13.65 43.785 6.51 35 6.51S19.075 13.615 19.075 22.4c0 8.295 6.37 15.12 14.49 15.855v5.67h-20.72A7.237 7.237 0 005.6 51.17v3.01c0 3.15 1.995 5.81 4.795 6.825v.175a2.33 2.33 0 002.31 2.31c1.19 0 2.17-.91 2.275-2.065h39.165a2.283 2.283 0 002.275 2.065 2.317 2.317 0 002.31-2.24c3.255-.7 5.705-3.605 5.705-7.07v-.77H53.83v-1.505h-.035zm-36.26 2.94l-1.96-1.96 1.96-1.96 1.96 1.96-1.96 1.96zM33.53 35.07c-6.335-.735-11.27-6.125-11.27-12.67 0-7.035 5.705-12.74 12.74-12.74S47.74 15.4 47.74 22.4c0 6.51-4.935 11.935-11.27 12.635V32.06a9.774 9.774 0 008.33-9.695c0-5.39-4.41-9.8-9.8-9.8-5.39 0-9.8 4.41-9.8 9.8 0 4.9 3.64 8.96 8.33 9.695v3.01zm0-11.06v4.865c-2.94-.7-5.145-3.325-5.145-6.475 0-3.64 2.975-6.615 6.615-6.615s6.615 2.975 6.615 6.615a6.607 6.607 0 01-5.145 6.44v-4.83c.42-.385.7-.945.7-1.575 0-1.19-.98-2.17-2.17-2.17s-2.17.98-2.17 2.17c0 .595.28 1.155.7 1.575zm17.78 29.715h-2.135V51.59h2.135v2.135z","fill":"#27AE60"}})])
          )
        }
      }
    